import React from 'react';
import { gatewaysApi } from '../../services/endpoints';
import { useApiData, StateBlock } from './useApiData';

/**
 * E1 — the first customer-facing gateway screen anywhere in the Sheba
 * ecosystem (the audit found neither the mobile app nor the customer
 * portal has one yet — only an installer-facing admin tool does).
 */
export default function Gateways() {
  const { data: gateways, loading, error, reload } = useApiData(() => gatewaysApi.list());

  return (
    <div>
      <h1 className="text-2xl font-bold mb-6">Gateways</h1>
      <StateBlock loading={loading} error={error} onRetry={reload} isEmpty={gateways?.length === 0} emptyLabel="No gateway registered on this account yet.">
        <div className="grid md:grid-cols-2 gap-4">
          {gateways?.map((g) => (
            <div key={g.id} className="glass rounded-xl p-5">
              <div className="flex items-center justify-between">
                <p className="font-semibold">{g.name || 'Sheba Gateway'}</p>
                <span className={`text-xs px-2 py-0.5 rounded-full ${g.is_online ? 'bg-green-500/20 text-green-400' : 'bg-white/10 text-white/40'}`}>
                  {g.is_online ? 'Online' : 'Offline'}
                </span>
              </div>
              <p className="text-white/40 text-xs mt-1">{g.gateway_type}</p>
              {g.firmware_version && (
                <p className="text-white/30 text-xs mt-1">Firmware {g.firmware_version}</p>
              )}
            </div>
          ))}
        </div>
      </StateBlock>
    </div>
  );
}
